import React from "react";
import { Box, IconButton, Typography, Tooltip } from "@mui/material";
import { ArrowBack, Clear } from "@mui/icons-material";
import {
  PopoverFontColorButtons,
  PopoverListButtons,
} from "../../../Utils/styledComps";
const CustomTextPopoverContent = ({
  selectedFeature,
  text,
  handleBackButtonClick,
  handlePopoverClose,
}) => {
  const renderPopoverContent = () => {
    if (selectedFeature) {
      const feature = text.find((item) => item.label === selectedFeature);
      return (
        <Box>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 1.25,
            py: 1
          }}>
            <Tooltip title="Back" arrow>
              <IconButton
                edge="start"
                onClick={handleBackButtonClick}
                aria-label="Go back"
                sx={{ borderRadius: 1 }}
              >
                <ArrowBack />
              </IconButton>
            </Tooltip>
            <Typography variant="h6" sx={{ color: 'action.hover', fontWeight: 800 }}>
              {selectedFeature}
            </Typography>
            <Tooltip title="Close menu" arrow>
              <IconButton
                edge="end"
                onClick={handlePopoverClose}
                aria-label="Close text menu"
                sx={{ borderRadius: 1 }}
              >
                <Clear />
              </IconButton>
            </Tooltip>
          </Box>
          <Box sx={{
            display: 'flex',
            gap: 1,
            m: 1.25,
            flexWrap: 'wrap'
          }}>
            {feature?.children?.map((obj, index) => (
              <Tooltip key={index} title={obj.label} arrow placement="bottom">
                <PopoverFontColorButtons
                  onClick={obj.onClick}
                  aria-label={obj.label}
                  sx={{
                    width: "auto",
                    height:
                      obj?.id === 1 || obj?.label === "Font Color"
                        ? "220px"
                        : "80px",
                    backgroundColor:
                      selectedFeature === "Font Color" ? "transparent" : "",
                    padding: 1,
                  }}
                >
                  <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 0.75
                  }}>
                    <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      {obj.icon}
                    </Box>
                    <Typography sx={{
                      fontSize: 12,
                      color: 'action.hover',
                      textAlign: 'center',
                      whiteSpace: 'nowrap'
                    }}>
                      {obj.label}
                    </Typography>
                  </Box>
                </PopoverFontColorButtons>
              </Tooltip>
            ))}
          </Box>
        </Box>
      );
    }

    return (
      <Box sx={{ minHeight: 115 }}>
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 1.25,
          py: 1
        }}>
          <Typography
            variant="h6"
            sx={{
              m: 0,
              color: 'action.hover',
              fontWeight: 800,
            }}
          >
            Text Edit
          </Typography>
          <Tooltip title="Close menu" arrow>
            <IconButton
              edge="end"
              onClick={handlePopoverClose}
              aria-label="Close text menu"
              sx={{ borderRadius: 1 }}
            >
              <Clear />
            </IconButton>
          </Tooltip>
        </Box>
        <Box sx={{
          display: 'flex',
          gap: 1,
          flexWrap: 'wrap',
          justifyContent: 'flex-start'
        }}>
          {text.map((obj, index) => (
            <Tooltip key={index} title={obj.label} arrow placement="bottom">
              <PopoverListButtons
                onClick={obj.onClick}
                aria-label={obj.label}
                sx={{
                  width: 90,
                  height: 60,
                  px: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column'
                }}
              >
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                  height: '100%'
                }}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 0.5,
                    height: 40,
                    mb: 0.5
                  }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {obj.icon}
                    </Box>
                    {obj.children ? (
                      <Typography sx={{ fontSize: 15, opacity: 0.85 }}>▾</Typography>
                    ) : null}
                  </Box>
                  <Typography sx={{
                    fontSize: 11,
                    color: 'action.hover',
                    textAlign: 'center',
                    whiteSpace: 'normal',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    width: '100%'
                  }}>
                    {obj.label}
                  </Typography>
                </Box>
              </PopoverListButtons>
            </Tooltip>
          ))}
        </Box>
      </Box>
    );
  };

  return <>{renderPopoverContent()}</>;
};

export default CustomTextPopoverContent;
